import { z } from "zod";

export const waitlistItem = z.object({
  id: z.uuid(),
  email: z.email(),
  launchUpdatesConsent: z.literal(true),
  createdAt: z.iso.datetime(),
  reviewedAt: z.iso.datetime().nullable(),
  reviewedBy: z.uuid().nullable(),
});
export const waitlistPage = z.object({
  items: z.array(waitlistItem),
  nextCursor: z.uuid().nullable(),
});
export const waitlistSummary = z.object({ newCount: z.number().int().nonnegative() });
export const waitlistReview = waitlistItem.pick({ id: true, reviewedAt: true, reviewedBy: true });
export type WaitlistItem = z.infer<typeof waitlistItem>;
export type WaitlistFilters = { status: "new" | "reviewed" | "all"; before?: string };
